import {
    ComponentCategory,
    ComponentElementManifest
} from "@bizform/type/model/component_element/ComponentElementManifest.model";
import {DefaultLayoutId} from "@bizform/type/model/component_element/DefaultLayoutId.model";
import {PluginType} from "@bizform/type/model/model/Plugin.model";
import {BfButton} from "../bf_component/button/BfButton";

/**
 * Button component element
 *
 * @since 0.0.1
 * @author Heungsoo Ham
 * @class
 */
export class BfGridYCallerAction extends BfButton {
    static readonly pluginType: string = PluginType.GRIDHANDLER;

    /* manifest */
    static readonly componentElementManifest: ComponentElementManifest = {
        uniqueId: "_OVv8QIUIIk1UH_CkXxmXnXJunPoVK4y",
        category: ComponentCategory.BUTTON,
        defaultLayoutId: DefaultLayoutId.ONLYCOMPONENTELEMENT,
        label: "Grid Call Actions",
        description: "Grid Call Actions",
        icon: "",
        property: null
    };
}
